module.exports = __webpack_public_path__ + "static/media/info_white.809683b8.svg";